<template>
  <div>
    <number-widget v-if="widget.type === 'number-widget'" gradient="false">
      <!-- 
         v-if="
          numericData &&
            numericData[widget.name] &&
            numericData[widget.name][period.year]
        "
       -->
      <template v-if="numericData && numericData[widget.name]">
        <h3 slot="header">
          {{ $t(widget.title) }}
          <v-chip>{{ humanShowedStart }} - {{ humanShowedEnd }} ({{ humanShowedYear }})</v-chip>
        </h3>
        <h3 class="display-1 font-weight-light primary--text">
          {{ numericData[widget.name][period.year] ? numericData[widget.name][period.year] : 0 }}
          €
          <span
            v-if="!numericData[widget.name][period.year]"
            class="warning--text font-weight-light text-right body-2"
          >
            {{ $t('Sin datos') }}
          </span>
        </h3>
        <h4 class="grey--text">
          <b>
            {{ humanShowedStart }} - {{ humanShowedEnd }} {{ humanShowedYear - 1 }} :
            {{
              numericData[widget.name][period.year - 1]
                ? numericData[widget.name][period.year - 1]
                : 0
            }}
            €
          </b>
        </h4>
        <br />
        <h3 class="title" v-if="numberDiff" :class="numberClass">
          {{ numberDiff }}
        </h3>
      </template>
      <template slot="widget-more">
        <v-card-title class="headline mb-0 secondary--text">
          <h3 primary-title>{{ $t(widget.title) }}</h3>
        </v-card-title>
        <div v-html="widget.description"></div>
      </template>
    </number-widget>
    <card-widget v-if="widget.type === 'card-widget'" media-height="auto">
      <template slot="widget-media">
        <ipm
          v-if="widget.name === 'ipm'"
          :userid="userid"
          :year="period.year"
          :start-month="period.startMonth"
          :end-month="period.endMonth"
          @showedperiod="setShowedPeriod"
        ></ipm>
        <gpm
          v-if="widget.name === 'gpm'"
          :userid="userid"
          :year="period.year"
          :start-month="period.startMonth"
          :end-month="period.endMonth"
          @showedperiod="setShowedPeriod"
        ></gpm>
        <bpm
          v-if="widget.name === 'bpm'"
          :userid="userid"
          :year="period.year"
          :start-month="period.startMonth"
          :end-month="period.endMonth"
          @showedperiod="setShowedPeriod"
        ></bpm>
        <gei
          v-if="widget.name === 'gei'"
          :userid="userid"
          :year="period.year"
          :start-month="period.startMonth"
          :end-month="period.endMonth"
          @showedperiod="setShowedPeriod"
        ></gei>

        <cdg
          v-if="widget.name === 'cdg'"
          :userid="userid"
          :year="period.year"
          :start-month="period.startMonth"
          :end-month="period.endMonth"
          @showedperiod="setShowedPeriod"
        ></cdg>
      </template>

      <template slot="widget-title">
        {{ $t(widget.title) }}
        <v-chip>{{ humanShowedStart }} - {{ humanShowedEnd }} ({{ humanShowedYear }})</v-chip>
      </template>
      <template slot="widget-body"></template>
      <template slot="widget-more">
        {{ widget.description }}
      </template>
    </card-widget>
  </div>
</template>

<script>
import Bpm from '../indicators/Bpm.vue';
import Gei from '../indicators/Gei.vue';
import Gpm from '../indicators/Gpm.vue';
import Ipm from '../indicators/Ipm.vue';
import Cdg from '../indicators/Cdg.vue';

import CardWidget from '../widgets/CardWidget.vue';
import NumberWidget from '../widgets/NumberWidget.vue';
export default {
  components: {
    Bpm,
    Gei,
    Gpm,
    Ipm,
    Cdg,
    CardWidget,
    NumberWidget,
  },
  props: {
    widget: {
      type: [Object],
    },
    userid: {
      type: [String, Number],
    },
    year: {
      type: [String, Number],
    },
    period: {
      type: Object,
      default() {
        return {
          year: 2020,
          trimester: null,
          startMonth: null,
          endMonth: null,
        };
      },
    },
    numericData: {
      type: Object,
    },
  },
  data() {
    return {
      showedPeriod: {
        year: this.year,
        startMonth: this.period.startMonth,
        endMonth: this.period.endMonth,
      },
    };
  },
  mounted() {
    console.log(this.config);
    console.log('SHOWED_PERIOD', this.showedPeriod);
  },
  computed: {
    humanShowedStart() {
      let sm = this.showedPeriod.startMonth ? this.showedPeriod.startMonth : 1;
      return this.$moment(this.showedPeriod.year + '-' + sm, 'Y-M')
        .startOf('month')
        .format('MMMM');
    },
    humanShowedEnd() {
      let em = this.showedPeriod.endMonth ? this.showedPeriod.endMonth : 12;

      return this.$moment(this.showedPeriod.year + '-' + em, 'Y-M')
        .endOf('month')
        .format('MMMM');
    },
    humanShowedYear() {
      return this.$moment(this.showedPeriod.year, 'YYYY').format('YYYY');
    },
    numberClass() {
      if (this.widget.type === 'number-widget') {
        if (this.widget.name === 'gt') {
          return {
            'error--text':
              this.numericData[this.widget.name][this.period.year] >
              this.numericData[this.widget.name][this.period.year - 1],
            'primary--text':
              this.numericData[this.widget.name][this.period.year] <=
              this.numericData[this.widget.name][this.period.year - 1],
          };
        } else {
          return {
            'error--text':
              this.numericData[this.widget.name][this.period.year] <=
              this.numericData[this.widget.name][this.period.year - 1],
            'primary--text':
              this.numericData[this.widget.name][this.period.year] >
              this.numericData[this.widget.name][this.period.year - 1],
          };
        }
      } else {
        return {};
      }
    },
    numberDiff() {
      if (this.widget.type === 'number-widget') {
        if (this.numericData[this.widget.name][this.period.year - 1]) {
          let numberDiff =
            (100 *
              (this.numericData[this.widget.name][this.period.year] -
                this.numericData[this.widget.name][this.period.year - 1])) /
            this.numericData[this.widget.name][this.period.year - 1];
          return numberDiff > 0
            ? '+' + Math.round(numberDiff) + ' %'
            : Math.round(numberDiff) + '%';
        }
      }
      return null;
    },
  },
  methods: {
    setShowedPeriod(period) {
      this.showedPeriod = period;
    },
  },
  watch: {
    period: {
      handler: function(val, oldVal) {
        if (this.widget.type === 'number-widget') {
          this.setShowedPeriod(this.period);
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
